import {
  actions,
  getAllQuotesAsync,
  createNewQuoteAsync,
  editQuoteAsync,
  deleteQuoteAsync,
} from './slices';

export const QuotesActions = {
  ...actions,
  getAllQuotesAsync,
  createNewQuoteAsync,
  editQuoteAsync,
  deleteQuoteAsync,
};
